//(function () {
//    'use strict';

//    angular.module("imApp").factory("p2ClientUpdateService", ['$ihttp', function ($ihttp) {
//        let service = {
//            listClientUpdates: function (parms) {
//                return $ihttp.post({
//                    method: 145,
//                    parameters: parms || {}
//                });
//            }
//        };

//        return service;
//    }]);
//})();
